import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-back-to-top', 
  templateUrl: './back-to-top.component.html',
  //styleUrls: ['./back-to-top.component.scss'] 
})
export class BackToTopComponent {
  @Input() centered: boolean = false;
}